import React, { useState, useEffect } from 'react'
import { useUpdateUserPicMutation } from '@/features/users/usersApiSlice'
import useAuth from '@/hooks/useAuth'
import PulseLoader from 'react-spinners/PulseLoader'

const EtUserPicUploadForm = () => {

  // First Created - 06 May 2025
  // Author - Atul Pandey

  // 1 - State Variables
  const { username } = useAuth()
  const [userpic, setUserpic] = useState(null)
  const [showSuccess, setShowSuccess] = useState(false)

  // 2 - RTK mutation for upload
  const [updateUserPic, {
    isSuccess,
    isLoading,
    isError,
    error
  }] = useUpdateUserPicMutation()

  // 3 - Trigger success feedback
  useEffect(() => {
    if (isSuccess) {
      setShowSuccess(true)
      setTimeout(() => setShowSuccess(false), 3000)
    }
  }, [isSuccess])

  // 4 - Handle Pic Change
  const handlePicChange = (e) => {
    const file = e.target.files[0]
    if (file) setUserpic(file)
  }

  // 5 - Handle Submit
  const handleSubmit = async (e) => {
    e.preventDefault()

    if (!userpic) {
      alert("Please select a picture to upload.")
      return
    }

    const formData = new FormData()
    formData.append('username', username)
    formData.append('userpic', userpic)

    try {
      await updateUserPic(formData).unwrap()
      setUserpic(null)
    } catch (err) {
      console.error('Upload failed:', err)
    }
  }

  return (
    <div className="bg-white rounded-lg shadow p-4 w-full max-w-md">
      {isLoading && <PulseLoader color="#ea580c" />}
      {isError && <p className="text-orange-700 text-sm">{error?.data?.message}</p>}
      {showSuccess && (
        <div className="text-green-700 text-sm font-semibold mb-2">
          Picture uploaded successfully!
        </div>
      )}

      <form onSubmit={handleSubmit} className="flex flex-col gap-4">
        <div>
          <label className="block text-xs text-gray-600">
            Logged in as: <span className="font-semibold text-black">{username}</span>
          </label>
        </div>

        <div>
          <label htmlFor="userpic" className="block text-sm font-bold text-gray-700">
            Select User Picture
          </label>
          <input
            id="userPic"
            name="userpic"
            type="file"
            onChange={handlePicChange}
            className="mt-1 block w-full border border-gray-300 rounded p-2 text-xs italic text-gray-700"
          />
        </div>

        <button
          type="submit"
          className="rounded-full bg-gradient-to-r from-orange-800 to-orange-400 w-fit px-4 py-2 text-white text-sm shadow hover:from-orange-400 hover:to-orange-800"
        >
          Upload Picture
        </button>
      </form>
    </div>
  )
}

export default EtUserPicUploadForm
